import { arrayMove } from '@dnd-kit/sortable';
import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';

interface Payload {
  layoutType: LayoutType;
  oldIndex: number;
  newIndex: number;
}

export const reorderSections = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, oldIndex, newIndex } = payload;
  const sections = state[layoutType].sections;

  if (oldIndex < 0 || newIndex < 0 || oldIndex >= sections.length || newIndex >= sections.length || oldIndex === newIndex) return;

  state[layoutType].sections = arrayMove(sections, oldIndex, newIndex);
  state[layoutType].sections.forEach((section, index) => {
    section.order = index;
  });
};
